import React from "react";
import PropTypes from "prop-types";
import Utility from "app/horoscope/utility/utility";
import { useTranslation } from "react-i18next";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function PlanetDataTable({ planetData }) {
    const { t } = useTranslation();
    return (
        <div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}></th>
                        <th style={thStyleCompact}>{t("PLANET")}</th>
                        <th style={thStyleCompact}>{t("Place")}</th>
                        <th style={thStyleCompact}>{t("Rashiya")}</th>
                        <th style={thStyleCompact}>{t("Nekatha")}</th>
                        <th style={thStyleCompact}>{t("RashiBala")}</th>
                        <th style={thStyleCompact}>{t("WAKRA")}</th>
                        <th style={thStyleCompact}>{t("Awasthawa")}</th>
                    </tr>
                </thead>
                <tbody>
                    {planetData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}><p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(row.planet)}` }} /></td>
                            <td style={tdStyleCompact}>{row.planet}</td>
                            <td style={tdStyleCompact}>{row.place}</td>
                            <td style={tdStyleCompact}>{row.rashiya}</td>
                            <td style={tdStyleCompact}>{row.nekatha}</td>
                            <td style={tdStyleCompact}>{row.ucha}</td>
                            <td style={tdStyleCompact}>{row.wakra}</td>
                            <td style={tdStyleCompact}>{row.awasthawa}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    PlanetDataTable.propTypes = {
        planetData: PropTypes.object.isRequired,
    };
}
